export default __webpack_public_path__ + "static/media/get-money.d0328c40.svg";